import '../css/transformations.css';
import justyna from "../transformations/justyna1.jpg";
import marcel from "../transformations/marcel.jpg";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";

export default function Transformations() {
  const responsive = {
    desktop: { breakpoint: { max: 3000, min: 1024 }, items: 1 },
    tablet: { breakpoint: { max: 1024, min: 464 }, items: 1 },
    mobile: { breakpoint: { max: 464, min: 0 }, items: 1 }
  };

  const transformations = [
    {
      img: justyna,
      alt: "Transformacja Justyny",
      name: "Justyna",
      desc: "Dzięki mojej pomocy osiągnęła wymarzoną sylwetkę"
    },
    {
      img: marcel,
      alt: "Transformacja Marcela",
      name: "Marcel",
      desc: "Dzięki mojej pomocy zmienił sylwetkę diametralnie"
    }
  ];

  return (
    <div className='transformations' id="transformations">
      <h1 className="outline">TRANSFORMACJE</h1>
      <Carousel
        swipeable
        draggable
        showDots
        responsive={responsive}
        ssr
        infinite
        autoPlay
        autoPlaySpeed={5000}
        keyBoardControl
        customTransition="all .5s"
        transitionDuration={500}
        containerClass="carousel-container"
        removeArrowOnDeviceType={["tablet", "mobile"]}
        dotListClass="custom-dot-list-style"
        itemClass="carousel-item-padding-40-px"
        aria-label="Karuzela transformacji"
      >
        {transformations.map((t, idx) => (
          <div className="transformation" key={idx}>
            <div className="transformation-img-wrapper">
              <img src={t.img} alt={t.alt} draggable={false} />
              <div className="transformation-overlay">
                <h2>{t.name}</h2>
                <span>{t.desc}</span>
              </div>
            </div>
          </div>
        ))}
      </Carousel>
    </div>
  );
}